var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNicknameEnter = function SvgNicknameEnter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#nickname_enter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.82 11.239a2 2 0 0 0-.42-.66L13.41.588a2.006 2.006 0 1 0-2.838 2.837L17.166 10H1.998a1.998 1.998 0 1 0 0 3.997h15.168L10.57 20.57a1.998 1.998 0 0 0 0 2.838 2 2 0 0 0 2.838 0l9.992-9.992a2 2 0 0 0 .42-.66c.2-.486.2-1.031 0-1.518Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nickname_enter_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgNicknameEnter;